import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AdditionalInfoStore {

}

export enum AdditionalInfoStoreKeys {

}
